import { render, staticRenderFns } from "./shipping_method.vue?vue&type=template&id=85f4b766&scoped=true&lang=pug"
import script from "./shipping_method.vue?vue&type=script&lang=js"
export * from "./shipping_method.vue?vue&type=script&lang=js"
import style0 from "./shipping_method.vue?vue&type=style&index=0&id=85f4b766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f4b766",
  null
  
)

export default component.exports